import React, { useState, useContext } from "react";
import NavBarComponent from "./NavBarComponent";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import PermissionContext from "../Store/permission-context";
import classes from "./MainContainer.module.css";
import { Container } from "react-bootstrap";
import { Link, Switch, Route, Redirect } from "react-router-dom";
import Headroom from "react-headroom";
import HomeComponent from "./pages/HomeComponent";
import NewRegistration from "./pages/NewRegistration";
import ViewUser from "./pages/ViewUser";
import ChangePassword from "./pages/ChangePassword";
import SupplyIn from "./pages/SupplyIn";
import ChangePrice from "./pages/ChangePrice";
import Sales from "./pages/Sales";
import GetReport from "./pages/GetReport";
import GetHistory from "./pages/GetHistory";
import GetSupplyReport from "./pages/GetSupplyReport";
import GetMyReport from "./pages/GetMyReport";
import CashFlow from "./pages/CashFlow";
// import RestoreBackup from "./pages/RestoreBackup";
import Inventory from "./pages/Inventory";
import GoodsReport from "./pages/GoodsReport";
import BackUp from "./pages/BackUp";
import ViewDebts from "./pages/ViewDebts";
import GetCustomerAndExpenditureReport from "./pages/GetCustomerAndExpenditureReport";
import Admin from "./pages/Admin";
import UpdateServer from "./pages/UpdateServer";
import Cookies from "universal-cookie";
import ExpiredPage from "./pages/ExpiredPage";

const MainContainer = () => {
  const cookies = new Cookies();
  const PCtx = useContext(PermissionContext);

  const [RoutePage, setRoutePage] = useState([
    { path: "/", component: HomeComponent },
    { path: PCtx.ThePath + "/addnewuser", component: NewRegistration },
    { path: PCtx.ThePath + "/viewusers", component: ViewUser },
    { path: PCtx.ThePath + "/changepassword", component: ChangePassword },
    { path: PCtx.ThePath + "/supplyin", component: SupplyIn },
    { path: PCtx.ThePath + "/changeprice", component: ChangePrice },
    { path: PCtx.ThePath + "/sales", component: Sales },
    { path: PCtx.ThePath + "/getreport", component: GetReport },
    { path: PCtx.ThePath + "/getsupplyreport", component: GetSupplyReport },
    { path: PCtx.ThePath + "/myreport", component: GetMyReport },
    { path: PCtx.ThePath + "/goodssummary", component: GoodsReport },
    { path: PCtx.ThePath + "/viewdebts", component: ViewDebts },
    { path: "/expireditems", component: ExpiredPage },
    { path: PCtx.ThePath + "/cashflow", component: CashFlow },
    { path: PCtx.ThePath + "/updateonline", component: UpdateServer },
    // { path: PCtx.ThePath + "/restorebackup", component: RestoreBackup },
    {
      path: PCtx.ThePath + "/customersreports",
      component: GetCustomerAndExpenditureReport,
    },
    { path: PCtx.ThePath + "/gethistory", component: GetHistory },
    { path: PCtx.ThePath + "/inventory", component: Inventory },
    { path: PCtx.ThePath + "/backup", component: BackUp },
    { path: PCtx.ThePath + "/admin", component: Admin },
  ]);

  return (
    <Container fluid className={classes.AllElements} style={{ padding: "0px" }}>
      <ReactNotifications />

      <NavBarComponent />

      {PCtx.logged ? (
        <Switch>
          {RoutePage.map((page, index) => (
            <Route exact {...page} key={index} />
          ))}
        </Switch>
      ) : (
        <Switch>
          <Route path="/" component={HomeComponent} />
        </Switch>
      )}
    </Container>
  );
};

export default MainContainer;
